import { Box, styled } from '@planne-software/uni/mui/material';

export const NoteRoot = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignSelf: 'flex-start',
  alignItems: 'center',
  gap: '0.25rem',
  padding: '0.25rem 0.5rem',
  borderRadius: '0.25rem',
  background: theme.tokens.colors['color-neutral-softest']!,
}));

export const NoteText = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  fontFamily: theme.typography.fontFamily,
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));
